import styled from 'styled-components'
export const StyledCloseButtonContainer = styled.div`
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
`
export const StyledBody = styled.div`
    padding-top: 10px;
    margin: 20px;
    text-align: center;
    display: flex;
    gap: 16px;
    flex-direction: column;
    align-items: center;
`
export const StyledButtonContainer = styled.div`
    width: 100%;
    margin: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 280px;
`
